module.exports = __webpack_public_path__ + "img/dis1.600c6d0e.png";